import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCheck, faClose, faRetweet } from '@fortawesome/free-solid-svg-icons';
import { Uploadfile } from 'src/app/models/IImagenFalla';
@Component({
    selector: 'cr-upload-file',
    templateUrl: './uploadfile.component.html',
    styleUrls: ['./uploadfile.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UploadFileComponent implements OnInit {
    public titulo : string = "ARCHIVO";
    public multiplefiles : boolean = false;
    public fileTypes : Array<string> = [];
    public _file : File | null = null;
    public files: File[] = [];
    public _data : any = {};
    public _dataResult : any = {
        oldData : new Uploadfile(),
        newData : new Uploadfile(),
        row:null,
    };
    public icons: any = {
        close   : faClose   ,
        check   : faCheck   ,
        reload  : faRetweet ,
    };
    public editMode : boolean = true;
    constructor(
        public dialogRef: MatDialogRef<UploadFileComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.fileTypes = data['fileTypes'];
        this._data = data;
        this.editMode = this._data['editMode'];
        this._dataResult['oldData'] = data['img'];
        this._dataResult.row = this._data.row;
    }

    ngOnInit(): void { }
    onOkClick(){
        if(this._dataResult['cambio']) this.dialogRef.close(this._dataResult);
        else this.onNoClick();
    }
    onNoClick(){
        this.dialogRef.close();
    }

    onSelect(event) {
        if(this.files.length + event.addedFiles.length > 1){
            event.rejectedFiles = [event.rejectedFiles, ...event.addedFiles];
            event.addedFiles.length = 0;
        }

        if(event.rejectedFiles.length > 0){
            let _fileNames = event.rejectedFiles.map(rf => rf.name).join(',');
        }
        this._dataResult['cambio'] = true;
        this.files.push(...event.addedFiles);
        this._file = this.files[0];
        this._dataResult['newData']['nameFile'] = this.files[0]['name'];
        this.getBase64(this._file).then(res => {
            this._dataResult['newData']['base64'] = res;
        });
    }
    onRemove(event) {
        this.files.splice(this.files.indexOf(event), 1);
        this._file = null;
    }
    getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    onChangeClick(){
        this._dataResult['newData']['id_file'] = this._dataResult['oldData']['id_file']
        this._dataResult['oldData'] = new Uploadfile();
        this._dataResult['cambio'] = true;
    }
}
